// extracted by mini-css-extract-plugin
export default {"headerManager":"Apps_headerManager__WD2ai","button":"Apps_button__gjG4T"};